import { Menu } from "native-base";

export default Menu;